import { RefObject, useEffect, MutableRefObject } from 'react';
import { isHtmlElementNode } from 'utils/elementHelpers';
import { isNotNull, isUndefined } from 'utils/tsHelpers';

const focusableElements =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

/** focuses on the first focusable element (see above) within the parent ref provided */
export function useFirstFocusableElement<T>(
  parentRef: RefObject<Element> | MutableRefObject<Element>,
  isDisabled = false,
  dependencyArray: T[] = [],
) {
  useEffect(() => {
    const focusedInnerElement = parentRef.current?.querySelector(focusableElements);
    if (
      !isDisabled &&
      isNotNull(focusedInnerElement) &&
      !isUndefined(focusedInnerElement) &&
      isHtmlElementNode(focusedInnerElement)
    ) {
      focusedInnerElement.focus();
    }
  }, dependencyArray);
}
